import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from './component/spinner/spinner.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgSelectModule } from '@ng-select/ng-select';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ClientUserReducer } from './store/client-user/client-user.reducer';
import { ClientUserEffect } from './store/client-user/client-user.effects';

@NgModule({
  declarations: [SpinnerComponent],
  imports: [
    CommonModule,
    NgSelectModule,
    ModalModule.forRoot(),
    StoreModule.forFeature('clientUser', ClientUserReducer),
    EffectsModule.forFeature([ClientUserEffect]),
  ],
  exports: [SpinnerComponent, NgSelectModule],
})
export class SharedModule {}
